import React, { useRef, useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { useLocation } from 'react-router';
import { connect } from 'react-redux';
import { IconContext } from 'react-icons';
import { ImArrowLeft2 } from 'react-icons/im';
import { MdSettings } from 'react-icons/md';
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from 'reactstrap';
import {
  getCloudImageUrl,
  convertToRupiah,
  BANK_TRANSFER,
  VIRTUAL_ACC,
  CREDIT_CARD,
} from '../../utils';
import AuthInterface, {
  UserCurrencyInterface,
} from '../../interface/reducers/auth';
import PengisianInterface from '../../interface/reducers/topup';
import { RESOURCE_URL } from '../../config';
import PendingTopUp from './KickCreditTabs/PendingTopUp';
import BodyTab from './KickCreditTabs/BodyTab';
import { doTopUp, walletHistory } from '../../actions/topUpAction';
import {
  doDisbursement,
  disbursementHistory,
  cashOutHistory,
} from '../../actions/disbursementAction';
import { doFetchUserBankAccount } from '../../actions/postalCodeAction';
import { doFetchProfile, doRefreshToken } from '../../actions/authAction';
import {
  doVerifyOtp,
  doSentCitCall,
  doSentSMS,
  doSubmitPhone,
} from '../../actions/saleActions';
import RouteHistoryInterface from '../../interface/router';
const userBalanceIcon = `${RESOURCE_URL}icons/kickcredit.png`;
import CashoutForm from './Modals/CashoutForm';
import TopupForm from './Modals/TopupForm';
import ModalSnapPay from '../Modals/ModalSnapPay';
import Paginations from './Pagination/Pagination';
import styled from 'styled-components';
import SellerVerification from '../PageSellerRegistration/SellerVerification';
import ModalUnverifiedUser from 'Pages/Home/Components/Organisms/ModalUnverifiedUser';

const TABS = [
  {
    title: 'Pending Top Up',
    value: 'pending_topup',
  },
  {
    title: 'Pending Cash Out',
    value: 'pending_cashout',
  },
  {
    title: 'Wallet Logs',
    value: 'wallet_logs',
  },
];

const IconReminder = styled.div`
  background-color: #159953;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  width: 15px;
  height: 15px;
  padding: 9px;
  margin-left: 5px;
  display: none;
`;

interface walletHistory extends stateToProps {
  isTopUpSubmit: boolean;
  isCashOutSubmit: boolean;
  dataUser: Array<Object>;
  dataTopUp: Array<Object>;
  dataCashOut: Array<Object>;
  dataWalletLog: Array<Object>;
  dataUserBank: Array<Object>;
  dataDisbursement: Array<Object>;
  history: RouteHistoryInterface;
  dataAuth: any;
  doPendingCashOut: (payload: any) => Promise<any>;
  topUpHistory: (payload: any) => Promise<any>;
  doTopUp: (payload: any) => Promise<any>;
  doDisbursement: (payload: any) => Promise<any>;
  doDisbursementHistory: (payload: any) => Promise<any>;
  getUserBankAccount: () => Promise;
  getProfile: () => Promise<any>;
}

function WalletHistory({
  isTopUpSubmit,
  isCashOutSubmit,
  dataUser,
  dataTopUp,
  dataCashOut,
  dataWalletLog,
  dataUserBank,
  dataDisbursement,
  history,
  doPendingCashOut,
  doTopUp,
  doDisbursement,
  topUpHistory,
  doDisbursementHistory,
  getUserBankAccount,
  getProfile,
  doSubmitPhone,
  doRefreshToken,
  doVerifyOtp,
  doSentCitCall,
  doSentSMS,
  dataAuth,
}: walletHistory): JSX.Element {
  const location = useLocation();

  const prevIsTopUpSubmit = usePrevious(isTopUpSubmit);
  const prevIsCashOutSubmit = usePrevious(isCashOutSubmit);
  const [status, setStatus] = useState('pending_topup');
  const [activeTabs, setActiveTabs] = useState('pending_topup');
  const [isModalCashOutOpened, setModalCashOutOpened] = useState(false);
  const [isModalTopUpOpened, setModalTopUpOpened] = useState(false);

  //seller verification
  const [isOpenSellerVerification, setOpenSellerVerification] = useState(false);
  const [phone, setPhone] = useState('');
  const [isOpenExistingModal, setIsOpenExistingModal] = useState(false);
  //end seller verification

  const [isShowModal, setIsShowModal] = useState(false);
  const [unverifiedType, setUnverifiedType] =
    useState<
      'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account'
    >('Top Up');

  const onClickUnverifiedUser = (
    val: 'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account',
  ) => {
    setIsShowModal(true);
    setUnverifiedType(val);
  };

  const toggleCashout = () => {
    if (dataAuth.userdata.roles.includes('unverified_user')) {
      onClickUnverifiedUser('Cash Out');
      return;
    }
    setModalCashOutOpened(!isModalCashOutOpened);
  };
  const toggleTopUp = () => {
    if (dataAuth.userdata.roles.includes('unverified_user')) {
      onClickUnverifiedUser('Top Up');
      return;
    }
    setModalTopUpOpened(!isModalTopUpOpened);
  };
  const holdBalance =
    parseInt(dataUser.current_balance) - parseInt(dataUser.balance);
  const [paymentConfirmState, setPaymentConfirmState] = useState({
    modalPaymentConfirm: {
      isOpenModalPayment: false,
      invoice_number: null,
      redirect_url: null,
    },
  });
  const [params, setParams] = useState({
    params: { sort_by: 'createdAt_desc', balance_source: 'balance' },
  });

  useEffect(() => {
    if (location.state?.fromCashoutConfirmationPage) {
      handleChangeTabs('pending_cashout');
    }
  }, [location.state]);

  useEffect(() => {
    getList(activeTabs);
    if (dataUserBank.length === 0) getUserBankAccount();
  }, []);

  //seller verification
  function toggleSellerVerification() {
    setOpenSellerVerification(!isOpenSellerVerification);
  }
  function toggleExistingModal() {
    setIsOpenExistingModal(!isOpenExistingModal);
  }
  function toggleCashoutVerification() {
    if (
      !dataUser.seller_verification &&
      dataUser.country_code === 'IDN' &&
      dataUser.roles.includes('seller')
    ) {
      toggleSellerVerification();
      setIsOpenExistingModal(!isOpenExistingModal);
    } else {
      toggleCashout();
    }
  }
  //end seller verification

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }

  const componentDidUpdate = async (
    prevIsTopUpSubmit,
    isTopUpSubmit,
    prevIsCashOutSubmit,
    isCashOutSubmit,
  ) => {
    if (
      (prevIsTopUpSubmit && prevIsTopUpSubmit !== isTopUpSubmit) ||
      (prevIsCashOutSubmit && prevIsCashOutSubmit !== isCashOutSubmit)
    ) {
      getList(activeTabs);
    }
  };
  useEffect(() => {
    componentDidUpdate(
      prevIsTopUpSubmit,
      isTopUpSubmit,
      prevIsCashOutSubmit,
      isCashOutSubmit,
    );
  }, [prevIsTopUpSubmit, isTopUpSubmit, prevIsCashOutSubmit, isCashOutSubmit]);

  function handleChangeTabs(targetTab: string) {
    setStatus(targetTab);
    setActiveTabs(targetTab);
    getList(targetTab);
  }

  function handleCashOutSubmit(payloads) {
    doDisbursement(payloads).then(() => getProfile());
  }

  function handleTopUpSubmit(payloads) {
    doTopUp(payloads);
  }

  const toggleModalPayment = (data = {}) => {
    setPaymentConfirmState({
      ...paymentConfirmState,
      modalPaymentConfirm: {
        isOpenModalPayment:
          !paymentConfirmState.modalPaymentConfirm.isOpenModalPayment,
        ...data,
      },
    });
  };

  const confirmPayment = ({
    invoice_number,
    invoice_url,
    payment_method,
    payment_via,
    total_amount,
  }) => {
    const pathname = `/payment_confirmation/${invoice_number}`;
    switch (payment_method) {
      case BANK_TRANSFER[0]:
        return this.props.history.push({
          pathname,
          search: `?transfer_amount=${parseInt(total_amount)}`,
        });
      case VIRTUAL_ACC[0]:
      case CREDIT_CARD[0]: {
        if (payment_via === 'vt') {
          toggleModalPayment({
            invoice_number: invoice_number,
            redirect_url: invoice_url,
          });
          return true;
        } else return window.open(invoice_url, '_blank');
      }

      default:
        return null;
    }
  };

  const getList = (activeTabs) => {
    switch (activeTabs) {
      case 'pending_topup':
        topUpHistory(params);
        break;
      case 'pending_cashout':
        doPendingCashOut(params.params);
        break;
      case 'wallet_logs':
        doDisbursementHistory(params);
        break;
      default:
        return topUpHistory(params);
    }
  };

  const paginationEachTab = (tab) => {
    switch (tab) {
      case 'pending_topup':
        return (
          dataTopUp.pengisian.status_code === 200 &&
          dataTopUp.pengisian.dataPengisian.length !== 0
        );
      case 'pending_cashout':
        return (
          dataCashOut.status_code === 200 &&
          dataCashOut.dataCashOut.length !== 0
        );
      case 'wallet_logs':
        return (
          dataWalletLog.status_code === 200 &&
          dataWalletLog.dataBalance.length !== 0
        );
      default:
        return false;
    }
  };

  const checkPageTab = (tab, keys) => {
    switch (tab) {
      case 'pending_topup':
        return dataTopUp.pengisian[keys];
      case 'pending_cashout':
        return dataCashOut[keys];
      case 'wallet_logs':
        return dataWalletLog[keys];
      default:
        return 0;
    }
  };

  const handleToGo = (e, page) => {
    e.preventDefault();
    setParams({
      params: {
        ...params.params,
        page,
      },
    });
  };

  useEffect(() => {
    getList(activeTabs);
  }, [params]);

  const RenderPagination = () => {
    if (paginationEachTab(activeTabs)) {
      return (
        <Paginations
          currentPage={checkPageTab(activeTabs, 'current_page')}
          lastPage={checkPageTab(activeTabs, 'last_page')}
          perPage={checkPageTab(activeTabs, 'per_page')}
          total={checkPageTab(activeTabs, 'total')}
          prevPageUrl
          handleGoto={handleToGo}
          nextPageUrl
          maxPage={5}
        />
      );
    }
    return null;
  };

  function renderTabContent(currentActiveTab: string) {
    switch (currentActiveTab) {
      case 'pending_topup':
        return (
          <BodyTab
            title="Pending Top Up"
            icon={getCloudImageUrl(userBalanceIcon, 400)}
            onRefreshList={() => getList(currentActiveTab)}
            data={dataTopUp.pengisian.dataPengisian}
            isFetching={dataTopUp.pengisian.isFetch}
            type="TOPUP"
            openPaymentConfirm={confirmPayment}
            paginationEachTab={() => paginationEachTab(currentActiveTab)}
            activeTabs={activeTabs}
            handleGoto={handleToGo}
            checkPageTab={checkPageTab}
            RenderPagination={RenderPagination}
          />
        );
      case 'pending_cashout':
        return (
          <BodyTab
            title="Pending Cashout"
            icon={getCloudImageUrl(userBalanceIcon, 400)}
            onRefreshList={() => getList(currentActiveTab)}
            data={dataCashOut.dataCashOut}
            isFetching={dataCashOut.isFetch}
            type="CASHOUT"
            paginationEachTab={() => paginationEachTab(currentActiveTab)}
            activeTabs={activeTabs}
            handleGoto={handleToGo}
            checkPageTab={checkPageTab}
            RenderPagination={RenderPagination}
          />
        );
      case 'wallet_logs':
        return (
          <BodyTab
            title="Wallet Logs"
            icon={getCloudImageUrl(userBalanceIcon, 400)}
            onRefreshList={() => getList(currentActiveTab)}
            data={dataWalletLog.dataBalance}
            isFetching={dataWalletLog.isFetch}
            type="WALLET_LOGS"
            paginationEachTab={() => paginationEachTab(currentActiveTab)}
            activeTabs={activeTabs}
            handleGoto={handleToGo}
            checkPageTab={checkPageTab}
            RenderPagination={RenderPagination}
          />
        );
      default:
        return;
    }
  }

  const onClickBack = () => {
    history.push('/user_dashboard');
  };

  return (
    <div className={'kick-credit-container'}>
      {isOpenSellerVerification && (
        <SellerVerification
          isExistingSeller={
            !dataUser.seller_verification && dataUser.roles.includes('seller')
          }
          isOpen={isOpenSellerVerification}
          toggle={toggleSellerVerification}
          doRefreshToken={doRefreshToken}
          doVerifyOtp={doVerifyOtp}
          doSentCitCall={doSentCitCall}
          doSentSMS={doSentSMS}
          doSubmitPhone={doSubmitPhone}
          phoneNumber={phone}
          setPhone={setPhone}
          toggleExistingModal={toggleExistingModal}
          isOpenExistingModal={isOpenExistingModal}
          setIsOpenExistingModal={setIsOpenExistingModal}
        />
      )}
      <CashoutForm
        title="Kick Credit"
        balance_source="BALANCE"
        amountFee={0}
        icon={getCloudImageUrl(userBalanceIcon, 400)}
        isOpen={isModalCashOutOpened}
        onToggle={toggleCashout}
        onSubmit={handleCashOutSubmit}
        balance={dataUser.balance}
        bankAccount={dataUserBank}
        dataDisburse={dataDisbursement}
        dataPassword={dataUserBank.have_password}
        handleChangeTabs={() => handleChangeTabs('wallet_logs')}
        history={history}
      />
      <TopupForm
        title="Kick Credit"
        isOpen={isModalTopUpOpened}
        onToggle={toggleTopUp}
        onSubmit={handleTopUpSubmit}
        dataTopUp={dataTopUp.topUp}
        balance={dataUser.balance}
        holdBalance={holdBalance}
        icon={getCloudImageUrl(userBalanceIcon, 400)}
      />
      <ModalSnapPay
        isCloseable
        isOpen={paymentConfirmState.modalPaymentConfirm.isOpenModalPayment}
        headerTitle={paymentConfirmState.modalPaymentConfirm.invoice_number}
        invoiceNumber={paymentConfirmState.modalPaymentConfirm.invoice_number}
        redirectUrl={paymentConfirmState.modalPaymentConfirm.redirect_url}
        onToggle={toggleModalPayment}
      />
      <div className={'title-container'}>
        <div className={'back-button'} onClick={onClickBack}>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <ImArrowLeft2 />
            </div>
          </IconContext.Provider>
        </div>
        <span className={'title'}>Kick Credit</span>
      </div>
      <div className={'kick-credit-info'}>
        <div className="balance-icon">
          <KickImage src={getCloudImageUrl(userBalanceIcon, 400)} />
        </div>
        <div className={'balance-info'}>
          <span className="balance">Balance</span>
          <span className="balance-amount">
            IDR {convertToRupiah(parseInt(dataUser.balance))}
          </span>
          <span className="balance-kick-points">
            Kick Points{' '}
            <strong>
              {convertToRupiah(parseInt(dataUser.locked_balance))}
            </strong>
          </span>
        </div>
        <div className={'button-wrapper'}>
          <Button
            style={{ marginBottom: window.screen.availWidth < 480 && '10px' }}
            onClick={toggleTopUp}
          >
            Top Up
          </Button>
          <Button onClick={toggleCashout}>Cash Out</Button>
        </div>
      </div>
      <div className="hold-balance-wrapper">
        <span>
          On Hold Balance: <strong>IDR {convertToRupiah(holdBalance)}</strong>
        </span>
        <IconReminder>!</IconReminder>
      </div>
      <div className={'tab-container'}>
        <div className="tab-header-wrapper">
          {TABS.map((t, i) => {
            let classDiv = 'tabs';
            if (activeTabs === t.value) classDiv += ' active';
            return (
              <div
                key={i}
                className={classDiv}
                onClick={() => handleChangeTabs(t.value)}
              >
                {t.title}
                {activeTabs === t.value && <div className={'is-active-tabs'} />}
              </div>
            );
          })}
        </div>
        <div className="pagination-wrapper d-none d-sm-block">
          {RenderPagination()}
        </div>
      </div>
      <div className={'tab-content'}>{renderTabContent(activeTabs)}</div>
      <ModalUnverifiedUser
        type={unverifiedType}
        isShow={isShowModal}
        setIsShow={setIsShowModal}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataTopUp: state.dataTopUp,
    dataUser: state.dataAuth.userdata,
    dataCashOut: state.dataDisbursement.cashout,
    dataUserBank: state.dataPostalCode.userBankAccount.data,
    dataDisbursement: state.dataDisbursement.disbursement,
    dataWalletLog: state.dataDisbursement.balance,
    isTopUpSubmit: state.dataTopUp.topUp.isSubmit,
    isCashOutSubmit: state.dataDisbursement.disbursement.isSubmit,
    dataAuth: state.dataAuth,
  };
};

const mapDispatchToProps = (dispatch: (arg: any) => any) => {
  return {
    topUpHistory: (query: any) => dispatch(walletHistory(query)),
    doDisbursementHistory: (query: any) => dispatch(disbursementHistory(query)),
    doPendingCashOut: (query: any) => dispatch(cashOutHistory(query)),
    doTopUp: (payload: any) => dispatch(doTopUp(payload)),
    doDisbursement: (payload: any) => dispatch(doDisbursement(payload)),
    getUserBankAccount: () => dispatch(doFetchUserBankAccount()),
    getProfile: () => dispatch(doFetchProfile()),
    doRefreshToken: () => dispatch(doRefreshToken()),
    doSentCitCall: (payload) => dispatch(doSentCitCall(payload)),
    doSentSMS: (payload) => dispatch(doSentSMS(payload)),
    doVerifyOtp: (payload) => dispatch(doVerifyOtp(payload)),
    doSubmitPhone: (payload) => dispatch(doSubmitPhone(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletHistory);
